import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './styles/lt-tabs.css';
import { createBrowserRouter, Navigate, Route, Routes, RouterProvider } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from 'react-redux';
import { apiEndpoints } from './Utils/ApiConfig';
import axios from 'axios';
import { addSchoolUserInfo } from './Store/Reducer-Actions/AuthStatusSlice';
import { addSchoolInfo } from './Store/Reducer-Actions/SchoolInfoSlice';
// import Header from './Components/Header';
import PrivateRoute from './Utils/PrivateRoute';
import PublicOnlyRoute from './Utils/PublicOnlyRoute';
import WrongRoutePage from './Pages/WrongRoutePage';
import PrivateLayout from './PrivateLayout';
import PrivateRouteByRole from './Components/PrivateRouteByRole';
import PublicLayout from './PublicLayout';
import axiosInterceptor from './Utils/axiosInterceptors';
import { isAuthenticatedStatusResponse } from './Utils/authStatus';






const OpenDashboardPage = React.lazy(() => import('./Pages/AdminPages/Dashboard'));
const OpenClerkDashboardPage = React.lazy(() => import('./Pages/AdminPages/ClerkDashboard'));
const OpenAddStudentPage = React.lazy(() => import('./Pages/AdminPages/AddStudent'));

// LOGIN & REGISTRATION RELATED STUFF
const OpenLoginPage = React.lazy(() => import('./LoginPages/Login'));
const OpenForgotPasswordPage = React.lazy(() => import('./LoginPages/ForgotPassword'));
const OpenResetPasswordPage = React.lazy(() => import('./LoginPages/ResetPassword'));
const OpenSchoolOnboadingPage = React.lazy(() => import('./LoginPages/OnboardSchool'));
const OpenSchoolAdminRegistrationPage = React.lazy(() => import('./LoginPages/RegisterSchoolAdmins'));
const OpenThrillionStaffRegistrationPage = React.lazy(() => import('./Pages/ApplicationAdmins/AddThrillionStaff'))
const OpenThrillionStaffPage = React.lazy(() => import('./Pages/ApplicationAdmins/ViewThrillionStaff'))
const OpenThrillionStaffProfilePage = React.lazy(() => import('./Pages/ApplicationAdmins/StaffProfile'))
const OpenManageSchoolsPage = React.lazy(() => import('./Pages/ApplicationAdmins/ManageSchools'))
const OpenManageSchoolPlansPage = React.lazy(() => import('./Pages/ApplicationAdmins/ManageSchoolPlans'))
const OpenAddClassesPage = React.lazy(() => import('./Pages/AdminPages/ClassesPages/AddClasses'))
const OpenViewAddedClasses = React.lazy(() => import('./Pages/AdminPages/ClassesPages/ViewClassesOffered'))

// Faculty Related Pages
const OpenAddFacultyPage = React.lazy(() => import('./Pages/AdminPages/AddFaculty'));
const OpenViewAllFacultyPage = React.lazy(() => import('./Pages/AdminPages/ViewAllFaculty'));
const OpenViewFacultyDetailPage = React.lazy(() => import('./Pages/AdminPages/ViewFacultyDetail'));
const OpenCalendarPage = React.lazy(() => import('./Components/Calander/Calendar'));


const OpenAddSectionsPage = React.lazy(() => import('./Pages/AdminPages/ClassesPages/AddSections'));
const OpenSuperAdminsDashboard = React.lazy(() => import('./Pages/ApplicationAdmins/SuperAdminDashboard'));
const OpenBillingInfoPage = React.lazy(() => import('./Pages/ApplicationAdmins/BillingInfo'));
const OpenBillingDetailsPage = React.lazy(() => import('./Pages/ApplicationAdmins/BillingDetails'));
const OpenBillingPaymentTransactionsPage = React.lazy(() =>
  import('./Pages/ApplicationAdmins/BillingPaymentTransactions')
);
const OpenHrPayrollPage = React.lazy(() => import('./Pages/ApplicationAdmins/HrPayroll'));
const OpenManageSidebarLayoutPage = React.lazy(() => import('./Pages/ApplicationAdmins/ManageSidebarLayout'));
const OpenAddBlogsPage = React.lazy(() => import('./Pages/ApplicationAdmins/AddBlogs'));
const OpenAddNewsArticlesPage = React.lazy(() => import('./Pages/ApplicationAdmins/AddNewsArticles'));
const OpenManageRolePermissionsPage = React.lazy(() => import('./Pages/ApplicationAdmins/ManageRolePermissions'));
const OpenVendorOrganizationsPage = React.lazy(() => import('./Pages/ApplicationAdmins/VendorOrganizations'));
const OpenVendorDashboardPage = React.lazy(() => import('./Pages/VendorOrganizations/VendorDashboard'));
const OpenVendorStaffPage = React.lazy(() => import('./Pages/VendorOrganizations/VendorStaff'));
const OpenDemoRequestsPage = React.lazy(() => import('./Pages/ApplicationAdmins/DemoRequests'));
const OpenAllSchoolsPage = React.lazy(() => import('./Pages/ApplicationAdmins/AllSchools'));
const OpenApplicationTestingPage = React.lazy(() => import('./Pages/ApplicationAdmins/ApplicationTesting'));
const OpenApplicationTestCaseTicketDetailsPage = React.lazy(() =>
  import('./Pages/ApplicationAdmins/ApplicationTestCaseTicketDetails')
);
const OpenSchoolsLoginPage = React.lazy(() => import('./LoginPages/SchoolsLogin'));

// Students Related Pages
const OpenViewAllStudents = React.lazy(() => import('./Pages/AdminPages/ViewAllStudents'));
const OpenStudentProfile = React.lazy(() => import('./Pages/AdminPages/ViewStudent'));
const OpenEditStudentPage = React.lazy(() => import('./Pages/AdminPages/EditStudent'));

const OpenStaffDashboard = React.lazy(() => import('./Pages/ApplicationAdmins/StaffDashboard'));
const OpenSupportLeadTicketsPage = React.lazy(() => import('./Pages/ApplicationAdmins/SupportLeadTickets'));
const OpenViewSchoolAdmins = React.lazy(() => import('./LoginPages/ViewRegisteredSchoolAdmins'));
// const OpenAddSubjectsPage = React.lazy(() => import('./Pages/AdminPages/SubjectsPages/AddSubjects'));
const OpenSubjectsPage = React.lazy(() => import('./Pages/AdminPages/SubjectsPages/Subjects'));

// FEES RELATED STUFF
const OpenAssignFeesPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/AssignFeeDetails'));
const OpenAssignFeePage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/AssignFee'));
const OpenCollectFeesPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/CollectFees'));
const OpenExpenseLodgerPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/expenseLodger'));
const OpenEmployeePayrollPage = React.lazy(() => import('./Pages/AdminPages/employeePayroll'));
const OpenMyPayslipsPage = React.lazy(() => import('./Pages/Shared/MyPayslipsPage'));
const OpenViewDetailedFees = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/ViewFeeDetails'))
const OpenFeesInfoPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/FeesInfo'))
const OpenFeeRemindersPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/FeeReminders'))
const OpenFeeArrearsPage = React.lazy(() => import('./Pages/AdminPages/FeesManagementPages/FeeArrears'))

// Marks Entry Related STUFF
const OpenIndividualSubjectMarksEntryPage = React.lazy(() => import('./Pages/FacultyPages/MarksEntryPages/AddIndividualSubjectMarks'));
const OpenViewMarksSheetPage = React.lazy(() => import('./Pages/FacultyPages/MarksEntryPages/ViewMarksSheet'));
const OpenAddPlanPage = React.lazy(() => import('./Pages/FacultyPages/AddPlan'));
const OpenShowActionPlanPage = React.lazy(() => import('./Pages/FacultyPages/ShowActionPlan'));
const OpenAssignSubjectsToExamPage = React.lazy(() => import('./Pages/FacultyPages/MarksEntryPages/AssignSubjectsToExam'));

// School Management Related Stuff
const OpenDiaryInfoSchoolAdminsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/DiaryInfo'));
const OpenViewTeachingPlanPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/ViewTeachingPlan'));
const OpenStudyMaterialPage = React.lazy(() => import('./Pages/SchoolManagement/StudyMaterial'));
const OpenCreateClassTimeTablePage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/CreateClassTimeTable'));
const OpenViewTimeTablePage = React.lazy(() => import('./Pages/Shared/ViewTimeTable'));
const OpenAcademicYearDetailsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/AcademicYear'));
const OpenMySchoolSettingsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/MySchoolSettings'));
const OpenKnowledgeBasePage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/KnowledgeBase'));
const OpenKnowledgeBaseFeaturePage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/KnowledgeBaseFeature'));
const OpenMyTodosPage = React.lazy(() => import('./Pages/Shared/MyTodos'));
const OpenSchoolInfoPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/SchoolInfo'));
const OpenAppBillingPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/AppBilling'));
const OpenSchoolWebsiteSettingsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/SchoolWebsiteSettings'));
const OpenAdmissionsEnquiryPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/AdmissionsEnquiry'));
const OpenSchoolLeavePolicyPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/SchoolLeavePolicy'));
const OpenSchoolLeaveRequestsInfoPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/SchoolLeaveRequestsInfo'));
const OpenAssignTasksPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/AssignTasks'));
const OpenTransportationSystemPage = React.lazy(() => import('./Pages/AdminPages/transportationSystem'));
const OpenStudentPromotionPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/StudentPromotion'));
const OpenAlumniPage = React.lazy(() => import('./Pages/AdminPages/Alumni'));
const OpenSchoolAdminTicketsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/SchoolAdminTickets'));
const OpenTicketInfoPage = React.lazy(() => import('./Pages/Shared/TicketInfoPage'));
const OpenDailyUpdatesPage = React.lazy(() => import('./Pages/AdminPages/DailyUpdates'));
const OpenAnnouncementsPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/Announcements'));

// Examination Related Stuff
const OpenAddExaminationPage = React.lazy(() => import('./Pages/AdminPages/ExaminationPages/Add_Examination'))

// Learn Thrillion UI Page Links
const OpenMarketingLayout = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/MarketingLayout'));
const OpenMarketingHomePage = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/pages/HomePage'));
const OpenMarketingWhyUsPage = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/pages/WhyUsPage'));
const OpenMarketingFeaturesPage = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/pages/FeaturesPage'));
const OpenMarketingPricingPage = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/pages/PricingPage'));
const OpenMarketingContactPage = React.lazy(() => import('./Pages/WebsitePages/ThrillionWebsite/pages/ContactPage'));


// FOR FACULTY PAGES
const OpenAddAttendancePage = React.lazy(() => import('./Pages/FacultyPages/StudentAttendance/AddAttendance'))
const OpenViewAttendancePage = React.lazy(() => import('./Pages/FacultyPages/StudentAttendance/ViewAttendance'))
const OpenViewAttendanceReportPage = React.lazy(() => import('./Pages/FacultyPages/StudentAttendance/AttendanceReport'))

// For Complaints Page
const OpenAddComplaintPage = React.lazy(() => import('./Pages/FacultyPages/AddComplaint'))
const OpenFacultyDashboardPage = React.lazy(() => import('./Pages/FacultyPages/FacultyDashboard'))
const OpenFacultyViewTasksPage = React.lazy(() => import('./Pages/FacultyPages/FacultyViewTask'))
const OpenFacultyLeaveDetailsPage = React.lazy(() => import('./Pages/FacultyPages/leaveDetails'))
const OpenFacultyAddDiaryPage = React.lazy(() => import('./Pages/FacultyPages/Diary/FacultyAddDiaryPage'))
const OpenFacultyAddSyllabusPlanningPage = React.lazy(() => import('./Pages/FacultyPages/FacultyAddSyllabusPlanning'))
const OpenFacultyViewSyllabusPlanningPage = React.lazy(() => import('./Pages/FacultyPages/FacultyViewSyllabusPlanning'))
const OpenAdminViewSyllabusPage = React.lazy(() => import('./Pages/AdminPages/SchoolManagement/AdminViewSyllabus'))
const OpenFacultyViewDiaryPage = React.lazy(() => import('./Pages/FacultyPages/Diary/FacultyViewDiaryPage'))

// Luxehara Accessories UI Page Links
const OpenLuxeharaAddOrdersPage = React.lazy(() => import('./Pages/Luxehara_accessories/AddOrders'));
const OpenLuxeharaAllOrdersPage = React.lazy(() => import('./Pages/Luxehara_accessories/AllOrders'));
const OpenLuxeharaDashboardPage = React.lazy(() => import('./Pages/Luxehara_accessories/LuxeharaDashboard'));
const OpenProfilePage = React.lazy(() => import('./Pages/Profile'));
const OpenSettingsPage = React.lazy(() => import('./Pages/Settings'));

function AppContent() {
  const [userData, setUserData] = useState()
  const dispatch = useDispatch();
  const logged_userId = userData?.user_id
  const showDropdown = useSelector((state) => state.sidebar?.data.showToggle)
  console.log("show toggle : ", showDropdown)

  // // Verify Token from Cookies, & set isAuth status as True
  useEffect(() => {
    axiosInterceptor.get(apiEndpoints?.verifyTokenApi, { withCredentials: true })
      .then((res) => {
        if (!isAuthenticatedStatusResponse(res)) {
          return;
        }
        console.log("Authentication status from API built:", res);
        setUserData(res.data);
          dispatch(addSchoolUserInfo({
            "user_authenticated": res.data.authenticated,
            "user_role": res.data.role,
            "user_user_email": res.data.user_email,
            "user_user_id": res.data.user_id,
            "user_username":
              [res.data.first_name, res.data.last_name].filter(Boolean).join(" ").trim() ||
              res.data.username,
            "user_first_name": res.data.first_name || "",
            "user_last_name": res.data.last_name || "",
            "user_mobile_number": res.data.mobile_number || "",
            "user_user_status": res.data.user_status || "",
            "user_school_id": res.data.school_id,
            "user_school_name": res.data.school_name,
            "user_school_branch": res.data.school_branch || "",
            "user_school_address": res.data.school_address || "",
            "user_profile_image_url": res.data.profile_image_url || "",
            "user_subscription_plan": res.data.subscription_plan || "",
          }));
      })
      .catch((err) => {
        console.log("App.js line 116 Error : ", err);
      });
  }, [dispatch]);


  // ************ Fetches onBoard School table data by loggedin user id 
  //               with this school data you will attach classes, sections, students, faculty etc. **********************************************

  // Task : Create one more API, where it fetches only school_id, official_email.. gettting complete data of school now.
  //  This increases data charges. use that API End-point below
  useEffect(() => {
    // Principal (1) and School Admin (2) share the same school portal access.
    const role = Number(userData?.role);
    if ([1, 2].includes(role) && logged_userId !== null) {
      axios.get(apiEndpoints.fetch_all_onboarded_schools_by_loggedIn_userId + logged_userId)
        .then((userData) => {
          if (userData.status === 200) {
            const data = userData.data.map((val) => { return val })
            data?.map((values) => (
              dispatch(addSchoolInfo({
                "schoolId": values.id,
                "schoolName": values.school_name,
                "schoolActiveStatus": values.active_status,
                "schoolOfficialEmail": values.school_official_email,
                "schoolPrincipal": values.school_principal
              }))
            ))
          }
        })
        .catch((error) => {
          console.log("fething onboarded school info by user has error : ", error)
        })
    }

  }, [dispatch, logged_userId, userData?.role])

  return (

    <Routes>
      <Route element={<PublicLayout />}>
        <Route
          element={
            <React.Suspense fallback="Loading..">
              <OpenMarketingLayout />
            </React.Suspense>
          }
        >
          <Route
            index
            element={
              <React.Suspense fallback="Loading..">
                <OpenMarketingHomePage />
              </React.Suspense>
            }
          />
          <Route
            path="why-us"
            element={
              <React.Suspense fallback="Loading..">
                <OpenMarketingWhyUsPage />
              </React.Suspense>
            }
          />
          <Route
            path="features"
            element={
              <React.Suspense fallback="Loading..">
                <OpenMarketingFeaturesPage />
              </React.Suspense>
            }
          />
          <Route
            path="pricing"
            element={
              <React.Suspense fallback="Loading..">
                <OpenMarketingPricingPage />
              </React.Suspense>
            }
          />
          <Route
            path="contact"
            element={
              <React.Suspense fallback="Loading..">
                <OpenMarketingContactPage />
              </React.Suspense>
            }
          />
        </Route>
        <Route path='/learn-thrillion/home' element={<Navigate to="/" replace />} />
        <Route element={<PublicOnlyRoute />}>
          <Route path='/schools-login' element={<React.Suspense fallback="Loading.."><OpenSchoolsLoginPage /></React.Suspense>} />
          <Route
            path='/login'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenLoginPage />
              </React.Suspense>
            }
          />
          <Route
            path='/forgot-password'
            element={
              <React.Suspense fallback="Loading..">
                <OpenForgotPasswordPage />
              </React.Suspense>
            }
          />
          <Route
            path='/reset-password'
            element={
              <React.Suspense fallback="Loading..">
                <OpenResetPasswordPage />
              </React.Suspense>
            }
          />
        </Route>
        <Route path='/wrong-route' element={<WrongRoutePage />} />
        <Route path="*" element={<WrongRoutePage />} />
      </Route>

      <Route element={<PrivateRoute />}>
        <Route element={<PrivateLayout />}>
          <Route element={<PrivateRouteByRole />}>
          <Route
            path='/dashboard'
            element={
              <React.Suspense fallback="Loading..">
                <OpenDashboardPage />
              </React.Suspense>
            }
          />

          <Route
            path='/clerk-dashboard'
            element={
              <React.Suspense fallback="Loading..">
                <OpenClerkDashboardPage />
              </React.Suspense>
            }
          />

          <Route
            path='/profile'
            element={
              <React.Suspense fallback="Loading..">
                <OpenProfilePage />
              </React.Suspense>
            }
          />

          <Route
            path='/settings'
            element={
              <React.Suspense fallback="Loading..">
                <OpenSettingsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-all-faculty'
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewAllFacultyPage />
              </React.Suspense>
            }
          />
          <Route
            path='/view-all-faculty/:facultyId'
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewFacultyDetailPage />
              </React.Suspense>
            }
          />
          <Route
            path='/my-school-settings'
            element={
              <React.Suspense fallback="Loading..">
                <OpenMySchoolSettingsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/knowledge-base'
            element={
              <React.Suspense fallback="Loading..">
                <OpenKnowledgeBasePage />
              </React.Suspense>
            }
          />
          <Route
            path='/knowledge-base/:featureSlug'
            element={
              <React.Suspense fallback="Loading..">
                <OpenKnowledgeBaseFeaturePage />
              </React.Suspense>
            }
          />

          <Route
            path='/my-todos'
            element={
              <React.Suspense fallback="Loading..">
                <OpenMyTodosPage />
              </React.Suspense>
            }
          />

          <Route
            path='/academic-year'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAcademicYearDetailsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/school-info'
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolInfoPage />
              </React.Suspense>
            }
          />

          <Route
            path='/school-website'
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolWebsiteSettingsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/admissions-enquiry'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAdmissionsEnquiryPage />
              </React.Suspense>
            }
          />

          <Route
            path='/school-leave-policy'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolLeavePolicyPage />
              </React.Suspense>
            }
          />

          <Route
            path='/school-leave-requests-info'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolLeaveRequestsInfoPage />
              </React.Suspense>
            }
          />

          <Route
            path='/assign-tasks'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAssignTasksPage />
              </React.Suspense>
            }
          />

          <Route
            path='/transportation-system'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenTransportationSystemPage />
              </React.Suspense>
            }
          />

          <Route
            path='/school-admin-tickets'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolAdminTicketsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/ticket-info'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenTicketInfoPage />
              </React.Suspense>
            }
          />

          <Route 
            path='/add-complaint'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddComplaintPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty-dashboard'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyDashboardPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty/view-tasks'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyViewTasksPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty-leave-details'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyLeaveDetailsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty/add-diary'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyAddDiaryPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty/view-diary'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyViewDiaryPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty/add-syllabus-planning'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyAddSyllabusPlanningPage />
              </React.Suspense>
            }
          />

          <Route
            path='/faculty/view-syllabus-planning'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenFacultyViewSyllabusPlanningPage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-syllabus'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAdminViewSyllabusPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-attendance-page'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddAttendancePage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-attendance-page'
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewAttendancePage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-attendance-report'
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewAttendanceReportPage />
              </React.Suspense>
            }
          />
          

          <Route
            path='/super-admins-dashboard'
            element={
              <React.Suspense fallback="Loading..">
                <OpenSuperAdminsDashboard />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/billing/payments'
            element={
              <React.Suspense fallback="Loading..">
                <OpenBillingPaymentTransactionsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/billing/:schoolId'
            element={
              <React.Suspense fallback="Loading..">
                <OpenBillingDetailsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/billing'
            element={
              <React.Suspense fallback="Loading..">
                <OpenBillingInfoPage />
              </React.Suspense>
            }
          />

          <Route
            path='/app-billing'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAppBillingPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/hr-payroll'
            element={
              <React.Suspense fallback="Loading..">
                <OpenHrPayrollPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/sidebar-layout'
            element={
              <React.Suspense fallback="Loading..">
                <OpenManageSidebarLayoutPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/add-blogs'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddBlogsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/add-news-articles'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddNewsArticlesPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/role-permissions'
            element={
              <React.Suspense fallback="Loading..">
                <OpenManageRolePermissionsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/super-admin/vendor-organizations'
            element={
              <React.Suspense fallback="Loading..">
                <OpenVendorOrganizationsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/vendor/dashboard'
            element={
              <React.Suspense fallback="Loading..">
                <OpenVendorDashboardPage />
              </React.Suspense>
            }
          />

          <Route
            path='/vendor/staff'
            element={
              <React.Suspense fallback="Loading..">
                <OpenVendorStaffPage />
              </React.Suspense>
            }
          />

          <Route
            path='/demo-requests'
            element={
              <React.Suspense fallback="Loading..">
                <OpenDemoRequestsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/all-schools'
            element={
              <React.Suspense fallback="Loading..">
                <OpenAllSchoolsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/application-testing'
            element={
              <React.Suspense fallback="Loading..">
                <OpenApplicationTestingPage />
              </React.Suspense>
            }
          />

          <Route
            path='/application-testing/ticket-details'
            element={
              <React.Suspense fallback="Loading..">
                <OpenApplicationTestCaseTicketDetailsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/staff-dashboard'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenStaffDashboard />
              </React.Suspense>
            }
          />

          <Route
            path='/support-lead/tickets'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSupportLeadTicketsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-student'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddStudentPage />
              </React.Suspense>
            }
          />


          <Route
            path='/diary-info'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenDiaryInfoSchoolAdminsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-teaching-plans'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewTeachingPlanPage />
              </React.Suspense>
            }
          />

          <Route
            path='/study-material'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenStudyMaterialPage />
              </React.Suspense>
            }
          />

          <Route
            path='/create-class-time-table'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenCreateClassTimeTablePage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-class-time-table'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewTimeTablePage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-all-school-admins'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewSchoolAdmins />
              </React.Suspense>
            }
          />

          <Route
            path='/view-all-students'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewAllStudents />
              </React.Suspense>
            }
          />

          <Route
            path='/student-promotion'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenStudentPromotionPage />
              </React.Suspense>
            }
          />

          <Route
            path='/alumni'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAlumniPage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-student-profile'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenStudentProfile />
              </React.Suspense>
            }
          />
          

          <Route
            path='/edit-student/:id'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenEditStudentPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-individual-subject-marks'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenIndividualSubjectMarksEntryPage />
              </React.Suspense>
            }
          />

          <Route
            path='/marks-sheet'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenViewMarksSheetPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-plan'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddPlanPage />
              </React.Suspense>
            }
          />

          <Route
            path='/action-plan/:planId'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenShowActionPlanPage />
              </React.Suspense>
            }
          />
          
          <Route
            path='/assign-subjects-to-examination'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAssignSubjectsToExamPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-faculty'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAddFacultyPage />
              </React.Suspense>
            }
          />


          <Route
            path='/add-subjects'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSubjectsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/view-thrillion-staff'
            exact
            element={
              <React.Suspense>
                <OpenThrillionStaffPage />
              </React.Suspense>
            }
          />

          <Route
            path='/thrillion-staff-profile/:staffId'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenThrillionStaffProfilePage />
              </React.Suspense>
            }
          />

          <Route
            path='/manage-schools'
            exact
            element={
              <React.Suspense>
                <OpenManageSchoolsPage />
              </React.Suspense>
            }
          />
          <Route
            path='/super-admin/school-plans'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenManageSchoolPlansPage />
              </React.Suspense>
            }
          />
          <Route
            path='/manage-subscription-plans'
            element={<Navigate to="/super-admin/school-plans" replace />}
          />

          <Route
            path='/add-classes'
            exact
            element={
              <React.Suspense><OpenAddClassesPage /></React.Suspense>
            }
          />

          <Route
            path='/assign-fee'
            exact
            element={
              <React.Suspense><OpenAssignFeePage /></React.Suspense>
            }
          />

          <Route
            path='/calendar'
            exact
            element={
              <React.Suspense><OpenCalendarPage /></React.Suspense>
            }
          />

          <Route
            path='/daily-updates'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenDailyUpdatesPage />
              </React.Suspense>
            }
          />

          <Route
            path='/announcements'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenAnnouncementsPage />
              </React.Suspense>
            }
          />

          <Route
            path='/add-sections'
            exact
            element={
              <React.Suspense><OpenAddSectionsPage /></React.Suspense>
            }
          />

          <Route
            path='/add-examinations'
            exact
            element={
              <React.Suspense><OpenAddExaminationPage /></React.Suspense>
            }
          />

          <Route
            path='/view-classes'
            exact
            element={
              <React.Suspense><OpenViewAddedClasses /></React.Suspense>
            }
          />


          <Route
            path='/assign-fees'
            exact
            element={
              <React.Suspense><OpenAssignFeesPage /></React.Suspense>
            }
          />

          <Route
            path='/fee-details-page'
            exact
            element={
              <React.Suspense><OpenViewDetailedFees /></React.Suspense>
            }
          />

          <Route
            path='/collect-fees'
            exact
            element={
              <React.Suspense><OpenCollectFeesPage /></React.Suspense>
            }
          />

          <Route
            path='/fees-info'
            exact
            element={
              <React.Suspense><OpenFeesInfoPage /></React.Suspense>
            }
          />

          <Route
            path='/fee-reminders'
            exact
            element={
              <React.Suspense><OpenFeeRemindersPage /></React.Suspense>
            }
          />

          <Route
            path='/fee-arrears'
            exact
            element={
              <React.Suspense><OpenFeeArrearsPage /></React.Suspense>
            }
          />

          <Route
            path='/expense-lodger'
            exact
            element={
              <React.Suspense><OpenExpenseLodgerPage /></React.Suspense>
            }
          />

          <Route
            path='/employee-payroll'
            exact
            element={
              <React.Suspense fallback="Loading.."><OpenEmployeePayrollPage /></React.Suspense>
            }
          />

          <Route
            path='/my-payslips'
            exact
            element={
              <React.Suspense fallback="Loading.."><OpenMyPayslipsPage /></React.Suspense>
            }
          />

          <Route
            path='/register-school-admins'
            exact
            element={
              <React.Suspense>
                <OpenSchoolAdminRegistrationPage />
              </React.Suspense>
            }
          />

          <Route
            path='/register-thrillion-staff'
            element={
              <React.Suspense><OpenThrillionStaffRegistrationPage /></React.Suspense>
            }
          />

          <Route
            path='/onboard'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenSchoolOnboadingPage />
              </React.Suspense>
            }
          />

          <Route
            path='/luxehara/add-orders'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenLuxeharaAddOrdersPage />
              </React.Suspense>
            }
          />

          <Route
            path='/luxehara/all-orders'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenLuxeharaAllOrdersPage />
              </React.Suspense>
            }
          />
          
          <Route
            path='/luxehara/luxehara-dashboard'
            exact
            element={
              <React.Suspense fallback="Loading..">
                <OpenLuxeharaDashboardPage />
              </React.Suspense>
            }
          />

          </Route>
        </Route>

      </Route>

    </Routes>
  );
}

const router = createBrowserRouter([
  {
    path: "/*",
    element: <AppContent />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
